import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-20 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://images.pexels.com/photos/3735218/pexels-photo-3735218.jpeg"
          alt="Sustainability"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0a1628]/90" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-4">
            Get Started
          </p>
          <h2 className="text-3xl lg:text-[2.75rem] font-light text-white mb-6 lg:whitespace-nowrap lg:leading-tight">
            Ready to transform your{' '}<span className="font-semibold">e-waste management?</span>
          </h2>
          <p className="text-gray-400 text-lg mb-10">
            Join leading enterprises in building a sustainable future. Request a pickup 
            or partner with us today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center gap-2 bg-[#4fd1c5] hover:bg-[#38b2ac] text-[#0a1628] px-8 py-4 font-semibold transition-all duration-500 ease-out"
              data-testid="cta-request-pickup-btn"
            >
              Request a Pickup
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link 
              to="/contact#partner" 
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white text-white px-8 py-4 font-semibold transition-all duration-500 ease-out"
              data-testid="cta-partner-btn"
            >
              Partner With Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
